module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../../node_modules/happypack/loader.js?id=jsx!./RefundApplyView.js"));
	}, "RefundApplyView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=RefundApplyView!./src/pages/Shop/Member/Wallet/Refund/RefundApply/RefundApplyView.js
// module id = 1087
// module chunks = 431